import { Checkbox, FormCheckboxProps } from 'semantic-ui-react'
import './index.css'

const Switch = (props: FormCheckboxProps) => {
  return <Checkbox {...props} toggle />
}

export default Switch
